<template>
  <v-container class="px-0">
    <v-row no-gutters>
      <v-col>
        <v-tabs background-color="#009964" center-active dark v-model="tab">
          <v-tab key="settingTab1" @click="loadMember">{{
            $t("label.personal_info")
          }}</v-tab>
          <v-tab key="settingTab2">{{ $t("label.change_email") }}</v-tab>
          <v-tab key="settingTab3">{{ $t("label.change_mobile") }}</v-tab>
          <v-tab key="settingTab4">{{ $t("label.reset_password") }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item key="settingTab1">
            <v-card flat class="ma-10">
              <v-row dense>
                <v-col lg="3" md="6" xs="11">
                  <v-text-field
                    v-model="Member.MemberNo"
                    :label="$t('label.member_no')"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-show="false">
                <v-col lg="3" md="6" xs="11">
                  <v-radio-group v-model="Member.RegisterType" readonly row>
                    <v-radio :label="$t('label.email')" value="EMAIL"></v-radio>
                    <v-radio :label="$t('label.sms')" value="SMS"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col lg="3" md="6" xs="11">
                  <v-text-field
                    v-model="Member.FirstName"
                    :label="$t('label.first_name')"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col lg="3" md="6" xs="11">
                  <v-text-field
                    v-model="Member.LastName"
                    :label="$t('label.last_name')"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col lg="3" md="6" xs="11">
                  <v-radio-group v-model="Member.Gender" row>
                    <v-radio :label="$t('label.male')" value="M"></v-radio>
                    <v-radio :label="$t('label.female')" value="F"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col lg="3" md="6" xs="11">
                  <select-country
                    v-model="Country"
                    :change="afterCountry"
                    item-text="CntyName"
                    item-value="CntyCode"
                    :label="$t('label.country')"
                    hide-no-data
                    :onChange="afterCountry"
                    ref="selectCountry"
                  ></select-country>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col class="d-flex mb-1">
                  <v-btn
                    class="mx-2"
                    color="secondary"
                    small
                    @click="updateMember"
                    >{{ $t("label.submit") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item key="settingTab2">
            <v-card flat class="ma-10" v-show="changeEmailStep == 1">
              <v-row dense>
                <v-col lg="3" md="6" xs="11">
                  <v-text-field
                    v-model="Member.Email"
                    :label="$t('label.email')"
                    type="email"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col class="d-flex mb-1">
                  <v-btn
                    class="mx-2"
                    color="secondary"
                    small
                    @click="resetChangeEmail"
                    >{{ $t("label.reset") }}</v-btn
                  >
                  <v-btn
                    class="mx-2"
                    color="secondary"
                    small
                    @click="verifyEmail"
                    >{{ $t("label.submit") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>

            <v-card flat class="ma-10" v-show="changeEmailStep == 2">
              <v-row dense>
                <v-col lg="3" md="6" xs="11">
                  <v-text-field
                    v-model="verifyEmailShortCode"
                    :label="$t('label.short_code')"
                    prefix="FG-"
                    type="text"
                    inputmode="decimal"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col class="d-flex mb-1">
                  <v-btn
                    class="mx-2"
                    color="secondary"
                    small
                    @click="resetChangeEmail"
                    >{{ $t("label.reset") }}</v-btn
                  >
                  <v-btn
                    class="mx-2"
                    color="secondary"
                    small
                    @click="updateEmail"
                    >{{ $t("label.submit") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item key="settingTab3">
            <v-card flat class="ma-10" v-show="changeMobileStep == 1">
              <v-row dense>
                <v-col lg="1" md="2" sm="3" xs="4">
                  <v-text-field
                    v-model="Member.MobilePrefix"
                    :label="$t('label.mobile_prefix')"
                    type="text"
                    inputmode="decimal"
                  ></v-text-field>
                </v-col>
                <v-col lg="2" md="4" sm="6" xs="8">
                  <v-text-field
                    v-model="Member.MobileNo"
                    :label="$t('label.mobile_no')"
                    type="text"
                    inputmode="decimal"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col class="d-flex mb-1">
                  <v-btn
                    class="mx-2"
                    color="secondary"
                    small
                    @click="resetChangeMobile"
                    >{{ $t("label.reset") }}</v-btn
                  >
                  <v-btn
                    class="mx-2"
                    color="secondary"
                    small
                    @click="verifyMobile"
                    >{{ $t("label.submit") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>

            <v-card flat class="ma-10" v-show="changeMobileStep == 2">
              <v-row dense>
                <v-col lg="3" md="6" xs="11">
                  <v-text-field
                    v-model="verifyMobileShortCode"
                    :label="$t('label.short_code')"
                    prefix="FG-"
                    type="text"
                    inputmode="decimal"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col class="d-flex mb-1">
                  <v-btn
                    class="mx-2"
                    color="secondary"
                    small
                    @click="resetChangeMobile"
                    >{{ $t("label.reset") }}</v-btn
                  >
                  <v-btn
                    class="mx-2"
                    color="secondary"
                    small
                    @click="updateMobile"
                    >{{ $t("label.submit") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item key="settingTab4">
            <v-form ref="updatePasswordForm" class="ma-10">
              <v-row dense>
                <v-col lg="3" md="6" xs="11">
                  <v-text-field
                    v-model="OriginalPassword"
                    :label="$t('label.original_password')"
                    required
                    :type="show1 ? 'text' : 'password'"
                    :append-icon="show1 ? mdiEye : mdiEyeOff"
                    @click:append="show1 = !show1"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col lg="3" md="6" xs="11">
                  <v-text-field
                    v-model="NewPassword"
                    :label="$t('label.new_password')"
                    :rules="passwordRules"
                    required
                    :type="show2 ? 'text' : 'password'"
                    :append-icon="show2 ? mdiEye : mdiEyeOff"
                    @click:append="show2 = !show2"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col lg="3" md="6" xs="11">
                  <v-text-field
                    v-model="ConfirmationPassword"
                    :label="$t('label.confirm_password')"
                    :rules="passwordRules"
                    required
                    :type="show3 ? 'text' : 'password'"
                    :append-icon="show3 ? mdiEye : mdiEyeOff"
                    @click:append="show3 = !show3"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col class="d-flex mb-1">
                  <v-btn
                    class="mx-2"
                    color="secondary"
                    small
                    @click="changePassword"
                    >{{ $t("label.submit") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-tab-item>
        </v-tabs-items>
        <v-snackbar :color="message_color" v-model="snackbar">
          {{ this.message }}
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar = false">
              <v-icon small>{{ mdiClose }}</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mdiEye, mdiEyeOff, mdiClose } from "@mdi/js";
import {
  GetMember,
  UpdateMember,
  UpdateMemberEmail,
  UpdateMemberMobile,
  VerifyBySmsMember,
  VerifyByEmailMember,
  ChangePassword,
} from "@/api/publicServices";
import i18n from "../lang/lang";

export default {
  metaInfo: {
    title: "設定",
    titleTemplate: "%s | 控制台 | 青蛙集運",
  },
  data: () => ({
    title: "label.setting",
    tab: null,
    OriginalPassword: "",
    NewPassword: "",
    ConfirmationPassword: "",
    emailRules: [
      (value) => !!value || i18n.t("label.required"),
      (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return (
          pattern.test(value) ||
          i18n.t("message.invalid_field", { type: i18n.t("label.email") })
        );
      },
    ],

    passwordRules: [
      (value) => !!value || i18n.t("label.required"),
      (value) => {
        //const pattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/
        const pattern = /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{6,30}$/;
        return pattern.test(value) || i18n.t("message.password_requirement");
      },
    ],
    Member: {
      MemberNo: "",
      RegisterType: "EMAIL",
      FirstName: "",
      LastName: "",
      Gender: "M",
      Country: "",
    },
    Email: "",
    Mobile: "",
    Country: {
      CntyCode: "HK",
      CntyName: "HONG KONG",
      CnName: "香港",
      TelPrefix: "852",
    },
    snackbar: false,
    message: "",
    message_color: "primary",
    changeEmailStep: 1,
    changeMobileStep: 1,
    verifyEmailShortCode: "",
    verifyMobileShortCode: "",
    emailVerificationID: "",
    mobileVerificationID: "",
    show1: false,
    show2: false,
    show3: false,

    //svg icons
    mdiEye,
    mdiEyeOff,
    mdiClose,
  }),
  components: {},
  mounted() {
    this.loadMember();
  },
  methods: {
    async changePassword() {
      if (this.OriginalPassword == "") {
        this.snackbar = true;
        this.message_color = "error";
        this.message = i18n.t("message.is_empty", {
          type: i18n.t("label.original_password"),
        });
        return;
      }

      if (this.NewPassword == "") {
        this.snackbar = true;
        this.message_color = "error";
        this.message = i18n.t("message.is_empty", {
          type: i18n.t("label.new_password"),
        });
        return;
      }

      if (this.ConfirmationPassword == "") {
        this.snackbar = true;
        this.message_color = "error";
        this.message = i18n.t("message.is_empty", {
          type: i18n.t("label.confirm_password"),
        });
        return;
      }

      if (this.NewPassword != this.ConfirmationPassword) {
        this.snackbar = true;
        this.message_color = "error";
        this.message = i18n.t("message.not_match", {
          type: i18n.t("label.password"),
        });
        return;
      }

      let data = {};
      data.OriginalPassword = this.OriginalPassword;
      data.ConfirmationPassword = this.ConfirmationPassword;
      data.NewPassword = this.NewPassword;

      try {
        const response = await ChangePassword(data);
        if (response.data.isSuccess) {
          this.snackbar = true;
          this.message_color = "primary";
          this.message = i18n.t("message.update_success");

          this.OriginalPassword = "";
          this.ConfirmationPassword = "";
          this.NewPassword = "";
          this.$refs.updatePasswordForm.reset()
        } else {
          this.snackbar = true;
          this.message_color = "error";
          this.message = response.data.Msg;
        }
      } catch (error) {
        console.log(error);
      }
    },
    resetChangeEmail() {
      this.changeEmailStep = 1;
      this.loadMember();
    },
    async verifyEmail() {
      let data = {};
      data.Email = this.Member.Email;
      try {
        const response = await VerifyByEmailMember(data);

        if (response.data.isSuccess) {
          this.emailVerificationID = response.data.Key;
          this.changeEmailStep = 2;
        } else {
          this.snackbar = true;
          this.message_color = "error";
          this.message = response.data.Msg;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async updateEmail() {
      let data = {};
      data.ShortCode = this.verifyEmailShortCode;
      data.Email = this.Member.Email;
      data.VerificationID = this.emailVerificationID;
      try {
        const response = await UpdateMemberEmail(data);

        if (response.data.isSuccess) {
          this.resetChangeEmail();
          this.snackbar = true;
          this.message_color = "primary";
          this.message = i18n.t("message.update_success");
          return;
        } else {
          this.snackbar = true;
          this.message_color = "error";
          this.message = response.data.Msg;
          return;
        }
      } catch (error) {
        console.log(error);
      }
    },

    resetChangeMobile() {
      this.changeMobileStep = 1;
      this.loadMember();
    },
    async verifyMobile() {
      let data = {};
      data.MobilePrefix = this.Member.MobilePrefix;
      data.MobileNo = this.Member.MobileNo;
      try {
        const response = await VerifyBySmsMember(data);

        if (response.data.isSuccess) {
          this.mobileVerificationID = response.data.Key;
          this.changeMobileStep = 2;
        } else {
          this.snackbar = true;
          this.message_color = "error";
          this.message = response.data.Msg;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async updateMobile() {
      let data = {};
      data.ShortCode = this.verifyMobileShortCode;
      data.MobilePrefix = this.Member.MobilePrefix;
      data.MobileNo = this.Member.MobileNo;
      data.VerificationID = this.mobileVerificationID;

      try {
        const response = await UpdateMemberMobile(data);
        console.log(response.data);
        if (response.data.isSuccess) {
          this.resetChangeMobile();
          this.snackbar = true;
          this.message_color = "primary";
          this.message = i18n.t("message.update_success");
          return;
        } else {
          this.snackbar = true;
          this.message_color = "error";
          this.message = response.data.Msg;
          return;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async updateMember() {
      this.Member.Country = this.Country.CntyCode;

      try {
        const response = await UpdateMember(this.Member);
        if (response.data.isSuccess) {
          this.loadMember();
          this.snackbar = true;
          this.message_color = "primary";
          this.message = i18n.t("message.update_success");
        } else {
          this.snackbar = true;
          this.message_color = "error";
          this.message = response.data.Msg;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async loadMember() {
      try {
        const response = await GetMember();
        this.Member = response.data;
        let Country = {};
        Country.CntyCode = this.Member.Country;
        //this.$refs.selectCountry.setCountry(Country)
      } catch (error) {
        console.log(error);
      }
    },
    afterCountry() {
      this.Member.MobilePrefix = "";
      if (this.Country != null) {
        this.Member.MobilePrefix = this.Country.TelPrefix;
      }
    },
  },
};
</script>
